export const ASYNCHRONOUS_VISIT_METHOD = 'asynchronous'

export const isAsynchronousVisitMethod = (method?: string | null): boolean => method === ASYNCHRONOUS_VISIT_METHOD

export const ONLINE_VISIT_LABEL_SUFFIX = '(Online)'

/**
 * Appends the "(Online)" suffix to a visit-type label for asynchronous (online) visits,
 * e.g. "Addiction treatment" -> "Addiction treatment (Online)". Live visits are unchanged.
 */
export const getVisitTypeLabel = (visitTypeName?: string, method?: string | null): string => {
  if (!visitTypeName) {
    return ''
  }

  return isAsynchronousVisitMethod(method) ? `${visitTypeName} ${ONLINE_VISIT_LABEL_SUFFIX}` : visitTypeName
}
